export const defaultUsers = [
  {
    id: "11111111-1111-1111-1111-111111111111",
    firstName: "Keith",
    lastName: "Reynolds",
    persona: "Administrator",
    email: "bkreynolds@fele.com",
    active: true,
  },
  {
    id: "22222222-2222-2222-2222-222222222222",
    firstName: "Steve",
    lastName: "Coker",
    persona: "Administrator",
    email: "steve.coker@fele.com",
    active: true,
  },
  {
    id: "33333333-3333-3333-3333-333333333333",
    firstName: "Josh",
    lastName: "Kennedy",
    persona: "Standard",
    email: "joshua.kennedy@fele.com",
    active: false,
  },
  {
    id: "44444444-4444-4444-4444-444444444444",
    firstName: "Isiah",
    lastName: "Jones",
    persona: "Sales",
    email: "isiah.jones@fele.com",
    active: true,
  },
  {
    id: "55555555-5555-5555-5555-555555555555",
    firstName: "Chris",
    lastName: "Owens",
    persona: "Purchasing",
    email: "cowens@fele.com",
    active: false,
  },
  {
    id: "66666666-6666-6666-6666-666666666666",
    firstName: "Romain",
    lastName: "Lopez",
    persona: "Standard",
    email: "romain.lopez@fele.com",
    active: true,
  },
  {
    id: "77777777-7777-7777-7777-777777777777",
    firstName: "Darrin",
    lastName: "Perry",
    persona: "Purchasing",
    email: "darrin.perry@fele.com",
    active: true,
  },
  {
    id: "88888888-8888-8888-8888-888888888888",
    firstName: "Juan",
    lastName: "Lopez",
    persona: "Purchasing",
    email: "juan.lopez@fele.com",
    active: false,
  },
  {
    id: "99999999-9999-9999-9999-999999999999",
    firstName: "Emily",
    lastName: "Clark",
    persona: "Standard",
    email: "emily.clark@fele.com",
    active: true,
  },
  {
    id: "10101010-1010-1010-1010-101010101010",
    firstName: "Michael",
    lastName: "Smith",
    persona: "Administrator",
    email: "michael.smith@fele.com",
    active: false,
  },
  {
    id: "11111111-aaaa-bbbb-cccc-111111111111",
    firstName: "Sarah",
    lastName: "Johnson",
    persona: "Storefront Administrator",
    email: "sarah.johnson@fele.com",
    active: true,
  },
  {
    id: "12121212-1212-1212-1212-121212121212",
    firstName: "David",
    lastName: "Williams",
    persona: "Sales",
    email: "david.williams@fele.com",
    active: true,
  },
  {
    id: "13131313-1313-1313-1313-131313131313",
    firstName: "Jessica",
    lastName: "Brown",
    persona: "Purchasing",
    email: "jessica.brown@fele.com",
    active: false,
  },
  {
    id: "14141414-1414-1414-1414-141414141414",
    firstName: "Matthew",
    lastName: "Davis",
    persona: "Standard + Import CSV",
    email: "matthew.davis@fele.com",
    active: true,
  },
  {
    id: "15151515-1515-1515-1515-151515151515",
    firstName: "Ashley",
    lastName: "Miller",
    persona: "Customer Administrator",
    email: "ashley.miller@fele.com",
    active: true,
  },
  {
    id: "16161616-1616-1616-1616-161616161616",
    firstName: "Joshua",
    lastName: "Wilson",
    persona: "Standard (No Ordering)",
    email: "joshua.wilson@fele.com",
    active: false,
  },
  {
    id: "17171717-1717-1717-1717-171717171717",
    firstName: "Amanda",
    lastName: "Moore",
    persona: "Sales Representative",
    email: "amanda.moore@fele.com",
    active: true,
  },
  {
    id: "18181818-1818-1818-1818-181818181818",
    firstName: "Daniel",
    lastName: "Taylor",
    persona: "Standard",
    email: "daniel.taylor@fele.com",
    active: false,
  },
  {
    id: "19191919-1919-1919-1919-191919191919",
    firstName: "Brittany",
    lastName: "Anderson",
    persona: "Administrator",
    email: "brittany.anderson@fele.com",
    active: true,
  },
  {
    id: "20202020-2020-2020-2020-202020202020",
    firstName: "Christopher",
    lastName: "Thomas",
    persona: "Storefront Administrator",
    email: "christopher.thomas@fele.com",
    active: false,
  },
  {
    id: "21212121-2121-2121-2121-212121212121",
    firstName: "Megan",
    lastName: "Jackson",
    persona: "Sales",
    email: "megan.jackson@fele.com",
    active: true,
  },
  {
    id: "22222222-2222-2222-2222-222222222222",
    firstName: "Andrew",
    lastName: "White",
    persona: "Purchasing",
    email: "andrew.white@fele.com",
    active: false,
  },
  {
    id: "23232323-2323-2323-2323-232323232323",
    firstName: "Lauren",
    lastName: "Harris",
    persona: "Standard + Import CSV",
    email: "lauren.harris@fele.com",
    active: true,
  },
  {
    id: "24242424-2424-2424-2424-242424242424",
    firstName: "Ryan",
    lastName: "Martin",
    persona: "Customer Administrator",
    email: "ryan.martin@fele.com",
    active: true,
  },
  {
    id: "25252525-2525-2525-2525-252525252525",
    firstName: "Stephanie",
    lastName: "Thompson",
    persona: "Standard (No Ordering)",
    email: "stephanie.thompson@fele.com",
    active: false,
  },
  {
    id: "26262626-2626-2626-2626-262626262626",
    firstName: "Brandon",
    lastName: "Garcia",
    persona: "Sales Representative",
    email: "brandon.garcia@fele.com",
    active: true,
  },
  {
    id: "27272727-2727-2727-2727-272727272727",
    firstName: "Nicole",
    lastName: "Martinez",
    persona: "Standard",
    email: "nicole.martinez@fele.com",
    active: false,
  },
  {
    id: "28282828-2828-2828-2828-282828282828",
    firstName: "Justin",
    lastName: "Robinson",
    persona: "Administrator",
    email: "justin.robinson@fele.com",
    active: true,
  },
  {
    id: "29292929-2929-2929-2929-292929292929",
    firstName: "Rachel",
    lastName: "Clark",
    persona: "Storefront Administrator",
    email: "rachel.clark@fele.com",
    active: true,
  },
  {
    id: "30303030-3030-3030-3030-303030303030",
    firstName: "Tyler",
    lastName: "Rodriguez",
    persona: "Sales",
    email: "tyler.rodriguez@fele.com",
    active: false,
  },
  {
    id: "31313131-3131-3131-3131-313131313131",
    firstName: "Samantha",
    lastName: "Lewis",
    persona: "Purchasing",
    email: "samantha.lewis@fele.com",
    active: true,
  },
  {
    id: "32323232-3232-3232-3232-323232323232",
    firstName: "Kevin",
    lastName: "Lee",
    persona: "Standard + Import CSV",
    email: "kevin.lee@fele.com",
    active: false,
  },
  {
    id: "33333333-aaaa-bbbb-cccc-333333333333",
    firstName: "Michelle",
    lastName: "Walker",
    persona: "Customer Administrator",
    email: "michelle.walker@fele.com",
    active: true,
  },
  {
    id: "34343434-3434-3434-3434-343434343434",
    firstName: "Jason",
    lastName: "Hall",
    persona: "Standard (No Ordering)",
    email: "jason.hall@fele.com",
    active: true,
  },
  {
    id: "35353535-3535-3535-3535-353535353535",
    firstName: "Elizabeth",
    lastName: "Allen",
    persona: "Sales Representative",
    email: "elizabeth.allen@fele.com",
    active: false,
  },
  {
    id: "36363636-3636-3636-3636-363636363636",
    firstName: "Brian",
    lastName: "Young",
    persona: "Standard",
    email: "brian.young@fele.com",
    active: true,
  },
  {
    id: "37373737-3737-3737-3737-373737373737",
    firstName: "Heather",
    lastName: "King",
    persona: "Administrator",
    email: "heather.king@fele.com",
    active: false,
  },
  {
    id: "38383838-3838-3838-3838-383838383838",
    firstName: "Eric",
    lastName: "Wright",
    persona: "Storefront Administrator",
    email: "eric.wright@fele.com",
    active: true,
  },
  {
    id: "39393939-3939-3939-3939-393939393939",
    firstName: "Melissa",
    lastName: "Lopez",
    persona: "Sales",
    email: "melissa.lopez@fele.com",
    active: true,
  },
  {
    id: "40404040-4040-4040-4040-404040404040",
    firstName: "Adam",
    lastName: "Scott",
    persona: "Purchasing",
    email: "adam.scott@fele.com",
    active: false,
  },
  {
    id: "41414141-4141-4141-4141-414141414141",
    firstName: "Kimberly",
    lastName: "Green",
    persona: "Standard + Import CSV",
    email: "kimberly.green@fele.com",
    active: true,
  },
  {
    id: "42424242-4242-4242-4242-424242424242",
    firstName: "Steven",
    lastName: "Adams",
    persona: "Customer Administrator",
    email: "steven.adams@fele.com",
    active: false,
  },
  {
    id: "43434343-4343-4343-4343-434343434343",
    firstName: "Rebecca",
    lastName: "Baker",
    persona: "Standard (No Ordering)",
    email: "rebecca.baker@fele.com",
    active: true,
  },
  {
    id: "44444444-aaaa-bbbb-cccc-444444444444",
    firstName: "Patrick",
    lastName: "Gonzalez",
    persona: "Sales Representative",
    email: "patrick.gonzalez@fele.com",
    active: true,
  },
  {
    id: "45454545-4545-4545-4545-454545454545",
    firstName: "Angela",
    lastName: "Nelson",
    persona: "Standard",
    email: "angela.nelson@fele.com",
    active: false,
  },
  {
    id: "46464646-4646-4646-4646-464646464646",
    firstName: "Jonathan",
    lastName: "Carter",
    persona: "Administrator",
    email: "jonathan.carter@fele.com",
    active: true,
  },
  {
    id: "47474747-4747-4747-4747-474747474747",
    firstName: "Katherine",
    lastName: "Mitchell",
    persona: "Storefront Administrator",
    email: "katherine.mitchell@fele.com",
    active: false,
  },
  {
    id: "48484848-4848-4848-4848-484848484848",
    firstName: "Benjamin",
    lastName: "Perez",
    persona: "Sales",
    email: "benjamin.perez@fele.com",
    active: true,
  },
  {
    id: "49494949-4949-4949-4949-494949494949",
    firstName: "Victoria",
    lastName: "Roberts",
    persona: "Purchasing",
    email: "victoria.roberts@fele.com",
    active: true,
  },
  {
    id: "50505050-5050-5050-5050-505050505050",
    firstName: "Alexander",
    lastName: "Turner",
    persona: "Standard + Import CSV",
    email: "alexander.turner@fele.com",
    active: false,
  },
  {
    id: "51515151-5151-5151-5151-515151515151",
    firstName: "Hannah",
    lastName: "Phillips",
    persona: "Customer Administrator",
    email: "hannah.phillips@fele.com",
    active: true,
  },
  {
    id: "52525252-5252-5252-5252-525252525252",
    firstName: "Jacob",
    lastName: "Campbell",
    persona: "Standard (No Ordering)",
    email: "jacob.campbell@fele.com",
    active: true,
  },
  {
    id: "53535353-5353-5353-5353-535353535353",
    firstName: "Olivia",
    lastName: "Parker",
    persona: "Sales Representative",
    email: "olivia.parker@fele.com",
    active: false,
  },
  {
    id: "54545454-5454-5454-5454-545454545454",
    firstName: "Ethan",
    lastName: "Evans",
    persona: "Standard",
    email: "ethan.evans@fele.com",
    active: true,
  },
  {
    id: "55555555-aaaa-bbbb-cccc-555555555555",
    firstName: "Natalie",
    lastName: "Edwards",
    persona: "Administrator",
    email: "natalie.edwards@fele.com",
    active: false,
  },
  {
    id: "56565656-5656-5656-5656-565656565656",
    firstName: "Dylan",
    lastName: "Collins",
    persona: "Storefront Administrator",
    email: "dylan.collins@fele.com",
    active: true,
  },
  {
    id: "57575757-5757-5757-5757-575757575757",
    firstName: "Grace",
    lastName: "Stewart",
    persona: "Sales",
    email: "grace.stewart@fele.com",
    active: false,
  },
  {
    id: "58585858-5858-5858-5858-585858585858",
    firstName: "Christian",
    lastName: "Sanchez",
    persona: "Purchasing",
    email: "christian.sanchez@fele.com",
    active: true,
  },
  {
    id: "59595959-5959-5959-5959-595959595959",
    firstName: "Madison",
    lastName: "Morris",
    persona: "Standard + Import CSV",
    email: "madison.morris@fele.com",
    active: true,
  },
  {
    id: "60606060-6060-6060-6060-606060606060",
    firstName: "Logan",
    lastName: "Rogers",
    persona: "Customer Administrator",
    email: "logan.rogers@fele.com",
    active: false,
  },
  {
    id: "61616161-6161-6161-6161-616161616161",
    firstName: "Chloe",
    lastName: "Reed",
    persona: "Standard (No Ordering)",
    email: "chloe.reed@fele.com",
    active: true,
  },
  {
    id: "62626262-6262-6262-6262-626262626262",
    firstName: "Nathan",
    lastName: "Cook",
    persona: "Sales Representative",
    email: "nathan.cook@fele.com",
    active: true,
  },
  {
    id: "63636363-6363-6363-6363-636363636363",
    firstName: "Ava",
    lastName: "Bailey",
    persona: "Administrator",
    email: "ava.bailey@fele.com",
    active: true,
  },
  {
    id: "64646464-6464-6464-6464-646464646464",
    firstName: "Ethan",
    lastName: "Rivera",
    persona: "Standard",
    email: "ethan.rivera@fele.com",
    active: false,
  },
  {
    id: "65656565-6565-6565-6565-656565656565",
    firstName: "Mia",
    lastName: "Cooper",
    persona: "Purchasing",
    email: "mia.cooper@fele.com",
    active: true,
  },
  {
    id: "66666666-6666-6666-6666-666666666667",
    firstName: "Alexander",
    lastName: "Ward",
    persona: "Sales",
    email: "alexander.ward@fele.com",
    active: false,
  },
  {
    id: "67676767-6767-6767-6767-676767676767",
    firstName: "Ella",
    lastName: "Morgan",
    persona: "Standard + Import CSV",
    email: "ella.morgan@fele.com",
    active: true,
  },
  {
    id: "68686868-6868-6868-6868-686868686868",
    firstName: "Benjamin",
    lastName: "Bell",
    persona: "Customer Administrator",
    email: "benjamin.bell@fele.com",
    active: false,
  },
  {
    id: "69696969-6969-6969-6969-696969696969",
    firstName: "Charlotte",
    lastName: "Murphy",
    persona: "Standard (No Ordering)",
    email: "charlotte.murphy@fele.com",
    active: true,
  },
  {
    id: "70707070-7070-7070-7070-707070707070",
    firstName: "Henry",
    lastName: "Rogers",
    persona: "Sales Representative",
    email: "henry.rogers@fele.com",
    active: true,
  },
  {
    id: "71717171-7171-7171-7171-717171717171",
    firstName: "Amelia",
    lastName: "Cook",
    persona: "Administrator",
    email: "amelia.cook@fele.com",
    active: false,
  },
  {
    id: "72727272-7272-7272-7272-727272727272",
    firstName: "Jack",
    lastName: "Peterson",
    persona: "Standard",
    email: "jack.peterson@fele.com",
    active: true,
  },
  {
    id: "73737373-7373-7373-7373-737373737373",
    firstName: "Harper",
    lastName: "Gray",
    persona: "Purchasing",
    email: "harper.gray@fele.com",
    active: true,
  },
  {
    id: "74747474-7474-7474-7474-747474747474",
    firstName: "Sebastian",
    lastName: "James",
    persona: "Sales",
    email: "sebastian.james@fele.com",
    active: false,
  },
  {
    id: "75757575-7575-7575-7575-757575757575",
    firstName: "Lily",
    lastName: "Watson",
    persona: "Standard + Import CSV",
    email: "lily.watson@fele.com",
    active: true,
  },
  {
    id: "76767676-7676-7676-7676-767676767676",
    firstName: "Logan",
    lastName: "Brooks",
    persona: "Customer Administrator",
    email: "logan.brooks@fele.com",
    active: false,
  },
  {
    id: "77777777-7777-7777-7777-777777777778",
    firstName: "Zoe",
    lastName: "Kelly",
    persona: "Standard (No Ordering)",
    email: "zoe.kelly@fele.com",
    active: true,
  },
  {
    id: "78787878-7878-7878-7878-787878787878",
    firstName: "Lucas",
    lastName: "Sanders",
    persona: "Sales Representative",
    email: "lucas.sanders@fele.com",
    active: true,
  },
  {
    id: "79797979-7979-7979-7979-797979797979",
    firstName: "Grace",
    lastName: "Price",
    persona: "Administrator",
    email: "grace.price@fele.com",
    active: false,
  },
  {
    id: "80808080-8080-8080-8080-808080808080",
    firstName: "Carter",
    lastName: "Bennett",
    persona: "Standard",
    email: "carter.bennett@fele.com",
    active: true,
  },
  {
    id: "81818181-8181-8181-8181-818181818181",
    firstName: "Scarlett",
    lastName: "Wood",
    persona: "Purchasing",
    email: "scarlett.wood@fele.com",
    active: true,
  },
  {
    id: "82828282-8282-8282-8282-828282828282",
    firstName: "Wyatt",
    lastName: "Barnes",
    persona: "Sales",
    email: "wyatt.barnes@fele.com",
    active: false,
  },
  {
    id: "83838383-8383-8383-8383-838383838383",
    firstName: "Victoria",
    lastName: "Ross",
    persona: "Standard + Import CSV",
    email: "victoria.ross@fele.com",
    active: true,
  },
  {
    id: "84848484-8484-8484-8484-848484848484",
    firstName: "Julian",
    lastName: "Henderson",
    persona: "Customer Administrator",
    email: "julian.henderson@fele.com",
    active: false,
  },
  {
    id: "85858585-8585-8585-8585-858585858585",
    firstName: "Penelope",
    lastName: "Coleman",
    persona: "Standard (No Ordering)",
    email: "penelope.coleman@fele.com",
    active: true,
  },
  {
    id: "86868686-8686-8686-8686-868686868686",
    firstName: "Levi",
    lastName: "Jenkins",
    persona: "Sales Representative",
    email: "levi.jenkins@fele.com",
    active: true,
  },
  {
    id: "87878787-8787-8787-8787-878787878787",
    firstName: "Layla",
    lastName: "Perry",
    persona: "Administrator",
    email: "layla.perry@fele.com",
    active: false,
  },
  {
    id: "88888888-8888-8888-8888-888888888889",
    firstName: "David",
    lastName: "Powell",
    persona: "Standard",
    email: "david.powell@fele.com",
    active: true,
  },
  {
    id: "89898989-8989-8989-8989-898989898989",
    firstName: "Nora",
    lastName: "Long",
    persona: "Purchasing",
    email: "nora.long@fele.com",
    active: true,
  },
  {
    id: "90909090-9090-9090-9090-909090909090",
    firstName: "Gabriel",
    lastName: "Patterson",
    persona: "Sales",
    email: "gabriel.patterson@fele.com",
    active: false,
  },
  {
    id: "91919191-9191-9191-9191-919191919191",
    firstName: "Hannah",
    lastName: "Hughes",
    persona: "Standard + Import CSV",
    email: "hannah.hughes@fele.com",
    active: true,
  },
  {
    id: "92929292-9292-9292-9292-929292929292",
    firstName: "Elijah",
    lastName: "Flores",
    persona: "Customer Administrator",
    email: "elijah.flores@fele.com",
    active: false,
  },
  {
    id: "93939393-9393-9393-9393-939393939393",
    firstName: "Aria",
    lastName: "Washington",
    persona: "Standard (No Ordering)",
    email: "aria.washington@fele.com",
    active: true,
  },
  {
    id: "94949494-9494-9494-9494-949494949494",
    firstName: "Matthew",
    lastName: "Butler",
    persona: "Sales Representative",
    email: "matthew.butler@fele.com",
    active: true,
  },
  {
    id: "95959595-9595-9595-9595-959595959595",
    firstName: "Sofia",
    lastName: "Simmons",
    persona: "Administrator",
    email: "sofia.simmons@fele.com",
    active: false,
  },
  {
    id: "96969696-9696-9696-9696-969696969696",
    firstName: "Jackson",
    lastName: "Foster",
    persona: "Standard",
    email: "jackson.foster@fele.com",
    active: true,
  },
  {
    id: "97979797-9797-9797-9797-979797979797",
    firstName: "Avery",
    lastName: "Gonzales",
    persona: "Purchasing",
    email: "avery.gonzales@fele.com",
    active: true,
  },
  {
    id: "98989898-9898-9898-9898-989898989898",
    firstName: "Daniel",
    lastName: "Bryant",
    persona: "Sales",
    email: "daniel.bryant@fele.com",
    active: false,
  },
  {
    id: "99999999-9999-9999-9999-999999999990",
    firstName: "Camila",
    lastName: "Alexander",
    persona: "Standard + Import CSV",
    email: "camila.alexander@fele.com",
    active: true,
  },
  {
    id: "10101010-2020-3030-4040-505050505050",
    firstName: "Luke",
    lastName: "Russell",
    persona: "Customer Administrator",
    email: "luke.russell@fele.com",
    active: false,
  },
  {
    id: "11111111-2222-3333-4444-555555555555",
    firstName: "Aurora",
    lastName: "Griffin",
    persona: "Standard (No Ordering)",
    email: "aurora.griffin@fele.com",
    active: true,
  },
  {
    id: "12121212-2323-3434-4545-565656565656",
    firstName: "Mason",
    lastName: "Diaz",
    persona: "Sales Representative",
    email: "mason.diaz@fele.com",
    active: true,
  },
  {
    id: "13131313-2424-3535-4646-575757575757",
    firstName: "Evelyn",
    lastName: "Hayes",
    persona: "Administrator",
    email: "evelyn.hayes@fele.com",
    active: false,
  },
  {
    id: "14141414-2525-3636-4747-585858585858",
    firstName: "Samuel",
    lastName: "Myers",
    persona: "Standard",
    email: "samuel.myers@fele.com",
    active: true,
  },
  {
    id: "15151515-2626-3737-4848-595959595959",
    firstName: "Ella",
    lastName: "Ford",
    persona: "Purchasing",
    email: "ella.ford@fele.com",
    active: true,
  },
  {
    id: "16161616-2727-3838-4949-606060606060",
    firstName: "Aiden",
    lastName: "Hamilton",
    persona: "Sales",
    email: "aiden.hamilton@fele.com",
    active: false,
  },
  {
    id: "17171717-2828-3939-5050-616161616161",
    firstName: "Sophie",
    lastName: "Graham",
    persona: "Standard + Import CSV",
    email: "sophie.graham@fele.com",
    active: true,
  },
  {
    id: "18181818-2929-4040-5151-626262626262",
    firstName: "Cameron",
    lastName: "Sullivan",
    persona: "Customer Administrator",
    email: "cameron.sullivan@fele.com",
    active: false,
  },
  {
    id: "19191919-3030-4141-5252-636363636363",
    firstName: "Stella",
    lastName: "Wallace",
    persona: "Standard (No Ordering)",
    email: "stella.wallace@fele.com",
    active: true,
  },
  {
    id: "20202020-3131-4242-5353-646464646464",
    firstName: "Owen",
    lastName: "West",
    persona: "Sales Representative",
    email: "owen.west@fele.com",
    active: true,
  },
  {
    id: "21212121-3232-4343-5454-656565656565",
    firstName: "Hazel",
    lastName: "Jordan",
    persona: "Administrator",
    email: "hazel.jordan@fele.com",
    active: false,
  },
  {
    id: "22222222-3333-4444-5555-666666666666",
    firstName: "Grayson",
    lastName: "Owens",
    persona: "Standard",
    email: "grayson.owens@fele.com",
    active: true,
  },
  {
    id: "23232323-3434-4545-5656-676767676767",
    firstName: "Violet",
    lastName: "Reynolds",
    persona: "Purchasing",
    email: "violet.reynolds@fele.com",
    active: true,
  },
  {
    id: "24242424-3535-4646-5757-686868686868",
    firstName: "Lincoln",
    lastName: "Fisher",
    persona: "Sales",
    email: "lincoln.fisher@fele.com",
    active: false,
  },
  {
    id: "25252525-3636-4747-5858-696969696969",
    firstName: "Madelyn",
    lastName: "Ellis",
    persona: "Standard + Import CSV",
    email: "madelyn.ellis@fele.com",
    active: true,
  },
  {
    id: "26262626-3737-4848-5959-707070707070",
    firstName: "Isaac",
    lastName: "Harrison",
    persona: "Customer Administrator",
    email: "isaac.harrison@fele.com",
    active: false,
  },
  {
    id: "27272727-3838-4949-6060-717171717171",
    firstName: "Aurora",
    lastName: "Gibson",
    persona: "Standard (No Ordering)",
    email: "aurora.gibson@fele.com",
    active: true,
  },
  {
    id: "28282828-3939-5050-6161-727272727272",
    firstName: "Ezra",
    lastName: "McDonald",
    persona: "Sales Representative",
    email: "ezra.mcdonald@fele.com",
    active: true,
  },
  {
    id: "29292929-4040-5151-6262-737373737373",
    firstName: "Savannah",
    lastName: "Cruz",
    persona: "Administrator",
    email: "savannah.cruz@fele.com",
    active: false,
  },
  {
    id: "30303030-4141-5252-6363-747474747474",
    firstName: "Hudson",
    lastName: "Marshall",
    persona: "Standard",
    email: "hudson.marshall@fele.com",
    active: true,
  },
  {
    id: "31313131-4242-5353-6464-757575757575",
    firstName: "Brooklyn",
    lastName: "Ortiz",
    persona: "Purchasing",
    email: "brooklyn.ortiz@fele.com",
    active: true,
  },
  {
    id: "32323232-4343-5454-6565-767676767676",
    firstName: "Dylan",
    lastName: "Kim",
    persona: "Sales",
    email: "dylan.kim@fele.com",
    active: false,
  },
  {
    id: "33333333-4444-5555-6666-777777777777",
    firstName: "Leah",
    lastName: "Hunter",
    persona: "Standard + Import CSV",
    email: "leah.hunter@fele.com",
    active: true,
  },
  {
    id: "34343434-4545-5656-6767-787878787878",
    firstName: "Luke",
    lastName: "Hicks",
    persona: "Customer Administrator",
    email: "luke.hicks@fele.com",
    active: false,
  },
  {
    id: "35353535-4646-5757-6868-797979797979",
    firstName: "Aubrey",
    lastName: "Crawford",
    persona: "Standard (No Ordering)",
    email: "aubrey.crawford@fele.com",
    active: true,
  },
  {
    id: "36363636-4747-5858-6969-808080808080",
    firstName: "Jayden",
    lastName: "Henry",
    persona: "Sales Representative",
    email: "jayden.henry@fele.com",
    active: true,
  },
  {
    id: "37373737-4848-5959-7070-818181818181",
    firstName: "Ellie",
    lastName: "Boyd",
    persona: "Administrator",
    email: "ellie.boyd@fele.com",
    active: false,
  },
  {
    id: "38383838-4949-6060-7171-828282828282",
    firstName: "Sebastian",
    lastName: "Mason",
    persona: "Standard",
    email: "sebastian.mason@fele.com",
    active: true,
  },
  {
    id: "39393939-5050-6161-7272-838383838383",
    firstName: "Paisley",
    lastName: "Warren",
    persona: "Purchasing",
    email: "paisley.warren@fele.com",
    active: true,
  },
  {
    id: "40404040-5151-6262-7373-848484848484",
    firstName: "Caleb",
    lastName: "Dixon",
    persona: "Sales",
    email: "caleb.dixon@fele.com",
    active: false,
  },
  {
    id: "41414141-5252-6363-7474-858585858585",
    firstName: "Nora",
    lastName: "Hunt",
    persona: "Standard + Import CSV",
    email: "nora.hunt@fele.com",
    active: true,
  },
  {
    id: "42424242-5353-6464-7575-868686868686",
    firstName: "Christian",
    lastName: "Black",
    persona: "Customer Administrator",
    email: "christian.black@fele.com",
    active: false,
  },
  {
    id: "43434343-5454-6565-7676-878787878787",
    firstName: "Lillian",
    lastName: "Daniels",
    persona: "Standard (No Ordering)",
    email: "lillian.daniels@fele.com",
    active: true,
  },
  {
    id: "44444444-5555-6666-7777-888888888888",
    firstName: "Anthony",
    lastName: "Stephens",
    persona: "Sales Representative",
    email: "anthony.stephens@fele.com",
    active: true,
  },
  {
    id: "45454545-5656-6767-7878-898989898989",
    firstName: "Addison",
    lastName: "Payne",
    persona: "Administrator",
    email: "addison.payne@fele.com",
    active: false,
  },
  {
    id: "46464646-5757-6868-7979-909090909090",
    firstName: "Christopher",
    lastName: "Pierce",
    persona: "Standard",
    email: "christopher.pierce@fele.com",
    active: true,
  },
  {
    id: "47474747-5858-6969-8080-919191919191",
    firstName: "Aaliyah",
    lastName: "Berry",
    persona: "Purchasing",
    email: "aaliyah.berry@fele.com",
    active: true,
  },
  {
    id: "48484848-5959-7070-8181-929292929292",
    firstName: "Joshua",
    lastName: "Matthews",
    persona: "Sales",
    email: "joshua.matthews@fele.com",
    active: false,
  },
  {
    id: "49494949-6060-7171-8282-939393939393",
    firstName: "Ariana",
    lastName: "Arnold",
    persona: "Standard + Import CSV",
    email: "ariana.arnold@fele.com",
    active: true,
  },
  {
    id: "50505050-6161-7272-8383-949494949494",
    firstName: "Eli",
    lastName: "Wagner",
    persona: "Customer Administrator",
    email: "eli.wagner@fele.com",
    active: false,
  },
  {
    id: "51515151-6262-7373-8484-959595959595",
    firstName: "Audrey",
    lastName: "Willis",
    persona: "Standard (No Ordering)",
    email: "audrey.willis@fele.com",
    active: true,
  },
  {
    id: "52525252-6363-7474-8585-969696969696",
    firstName: "Nathan",
    lastName: "Ray",
    persona: "Sales Representative",
    email: "nathan.ray@fele.com",
    active: true,
  },
  {
    id: "53535353-6464-7575-8686-979797979797",
    firstName: "Samantha",
    lastName: "Watts",
    persona: "Administrator",
    email: "samantha.watts@fele.com",
    active: false,
  },
  {
    id: "54545454-6565-7676-8787-989898989898",
    firstName: "Aaron",
    lastName: "Olson",
    persona: "Standard",
    email: "aaron.olson@fele.com",
    active: true,
  },
  {
    id: "55555555-6666-7777-8888-999999999999",
    firstName: "Mila",
    lastName: "Carroll",
    persona: "Purchasing",
    email: "mila.carroll@fele.com",
    active: true,
  },
  {
    id: "56565656-6767-7878-8989-101010101011",
    firstName: "Evan",
    lastName: "Dean",
    persona: "Sales",
    email: "evan.dean@fele.com",
    active: false,
  },
  {
    id: "57575757-6868-7979-9090-111111111112",
    firstName: "Lucy",
    lastName: "Wells",
    persona: "Standard + Import CSV",
    email: "lucy.wells@fele.com",
    active: true,
  },
  {
    id: "58585858-6969-8080-9191-121212121213",
    firstName: "Isaiah",
    lastName: "Wheeler",
    persona: "Customer Administrator",
    email: "isaiah.wheeler@fele.com",
    active: false,
  },
  {
    id: "59595959-7070-8181-9292-131313131314",
    firstName: "Anna",
    lastName: "Chapman",
    persona: "Standard (No Ordering)",
    email: "anna.chapman@fele.com",
    active: true,
  },
  {
    id: "60606060-7171-8282-9393-141414141415",
    firstName: "Hunter",
    lastName: "Mendez",
    persona: "Sales Representative",
    email: "hunter.mendez@fele.com",
    active: true,
  },
  {
    id: "61616161-7272-8383-9494-151515151516",
    firstName: "Claire",
    lastName: "Parks",
    persona: "Administrator",
    email: "claire.parks@fele.com",
    active: false,
  },
  {
    id: "62626262-7373-8484-9595-161616161617",
    firstName: "Adrian",
    lastName: "Austin",
    persona: "Standard",
    email: "adrian.austin@fele.com",
    active: true,
  },
  {
    id: "63636363-7474-8585-9696-171717171718",
    firstName: "Sadie",
    lastName: "Hicks",
    persona: "Purchasing",
    email: "sadie.hicks@fele.com",
    active: true,
  },
  {
    id: "64646464-7575-8686-9797-181818181819",
    firstName: "Jonathan",
    lastName: "Armstrong",
    persona: "Sales",
    email: "jonathan.armstrong@fele.com",
    active: false,
  },
  {
    id: "65656565-7676-8787-9898-191919191920",
    firstName: "Skylar",
    lastName: "Daniels",
    persona: "Standard + Import CSV",
    email: "skylar.daniels@fele.com",
    active: true,
  },
  {
    id: "66666666-7777-8888-9999-202020202021",
    firstName: "Brayden",
    lastName: "Carr",
    persona: "Customer Administrator",
    email: "brayden.carr@fele.com",
    active: false,
  },
  {
    id: "67676767-7878-8989-1010-212121212122",
    firstName: "Paisley",
    lastName: "Stone",
    persona: "Standard (No Ordering)",
    email: "paisley.stone@fele.com",
    active: true,
  },
  {
    id: "68686868-7979-9090-1111-222222222223",
    firstName: "Leo",
    lastName: "Williamson",
    persona: "Sales Representative",
    email: "leo.williamson@fele.com",
    active: true,
  },
  {
    id: "69696969-8080-9191-1212-232323232324",
    firstName: "Ariana",
    lastName: "Woods",
    persona: "Administrator",
    email: "ariana.woods@fele.com",
    active: false,
  },
  {
    id: "70707070-8181-9292-1313-242424242425",
    firstName: "Jaxon",
    lastName: "Dunn",
    persona: "Standard",
    email: "jaxon.dunn@fele.com",
    active: true,
  },
  {
    id: "71717171-8282-9393-1414-252525252526",
    firstName: "Ruby",
    lastName: "Hawkins",
    persona: "Purchasing",
    email: "ruby.hawkins@fele.com",
    active: true,
  },
  {
    id: "72727272-8383-9494-1515-262626262627",
    firstName: "Connor",
    lastName: "Wheeler",
    persona: "Sales",
    email: "connor.wheeler@fele.com",
    active: false,
  },
  {
    id: "73737373-8484-9595-1616-272727272728",
    firstName: "Peyton",
    lastName: "Fields",
    persona: "Standard + Import CSV",
    email: "peyton.fields@fele.com",
    active: true,
  },
  {
    id: "74747474-8585-9696-1717-282828282829",
    firstName: "Easton",
    lastName: "Warren",
    persona: "Customer Administrator",
    email: "easton.warren@fele.com",
    active: false,
  },
  {
    id: "75757575-8686-9797-1818-292929292930",
    firstName: "Bella",
    lastName: "Fox",
    persona: "Standard (No Ordering)",
    email: "bella.fox@fele.com",
    active: true,
  },
  {
    id: "76767676-8787-9898-1919-303030303031",
    firstName: "Eli",
    lastName: "Rice",
    persona: "Sales Representative",
    email: "eli.rice@fele.com",
    active: true,
  },
  {
    id: "77777777-8888-9999-2020-313131313132",
    firstName: "Autumn",
    lastName: "Webb",
    persona: "Administrator",
    email: "autumn.webb@fele.com",
    active: false,
  },
  {
    id: "78787878-8989-1010-2121-323232323233",
    firstName: "Colton",
    lastName: "Greene",
    persona: "Standard",
    email: "colton.greene@fele.com",
    active: true,
  },
  {
    id: "79797979-9090-1111-2222-333333333334",
    firstName: "Alexa",
    lastName: "Robertson",
    persona: "Purchasing",
    email: "alexa.robertson@fele.com",
    active: true,
  },
  {
    id: "80808080-9191-1212-2323-343434343435",
    firstName: "Bentley",
    lastName: "Howell",
    persona: "Sales",
    email: "bentley.howell@fele.com",
    active: false,
  },
  {
    id: "81818181-9292-1313-2424-353535353536",
    firstName: "Naomi",
    lastName: "Hansen",
    persona: "Standard + Import CSV",
    email: "naomi.hansen@fele.com",
    active: true,
  },
  {
    id: "82828282-9393-1414-2525-363636363637",
    firstName: "Xavier",
    lastName: "Pena",
    persona: "Customer Administrator",
    email: "xavier.pena@fele.com",
    active: false,
  },
  {
    id: "83838383-9494-1515-2626-373737373738",
    firstName: "Elena",
    lastName: "Beck",
    persona: "Standard (No Ordering)",
    email: "elena.beck@fele.com",
    active: true,
  },
  {
    id: "84848484-9595-1616-2727-383838383839",
    firstName: "Adam",
    lastName: "Newman",
    persona: "Sales Representative",
    email: "adam.newman@fele.com",
    active: true,
  },
];

export const personas = [
  "Storefront Administrator",
  "Administrator",
  "Customer Administrator",
  "Standard + Import CSV",
  "Standard",
  "Standard (No Ordering)",
  "Sales Representative",
  "Purchasing",
  "Sales",
  "Stnd No Ord/View Price",
  "Purchasing - With Availability By Location",
  "Standard - Availability",
];

export const SAMPLE_CUSTOMERS = [
  {
    id: 1014,
    name: "FRANKLIN ELECTRIC CO INC",
    Address_LineOne: "9255 COVEDALE RD",
    Address_City: "FORT WAYNE",
    Address_State: "IN",
    Address_PostalCode: "46809",
    Address_Country: "US",
    CompanyCode: "09000",
    BrandCode: "099",
    SalesTerritoryCode: "088",
    PaymentTerms: "N30",
    TaxId: "3508274555",
  },
  {
    id: 1800,
    name: "FRANKLIN ELECTRIC CO INC",
    Address_LineOne: "400 E SPRING ST",
    Address_LineTwo: "INDUSTRIAL ALIMENTARIA NO. 2001",
    Address_City: "BLUFFTON",
    Address_State: "IN",
    Address_PostalCode: "46714",
    Address_Country: "US",
    CompanyCode: "01400",
    BrandCode: "099",
    SalesTerritoryCode: "088",
    PaymentTerms: "DUR",
    TaxId: "850352228",
  },
  {
    id: 1950,
    name: "FRANKLIN PUMP SYSTEMS INC",
    Address_LineOne: "9255 COVERDALE RD",
    Address_LineTwo: "Ste 100",
    Address_City: "OLIVE BRANCH",
    Address_State: "MS",
    Address_PostalCode: "38654",
    Address_Country: "US",
    CompanyCode: "01950",
    BrandCode: "088",
    SalesTerritoryCode: "088",
    PaymentTerms: "N30",
    TaxId: "201589814",
  },
  {
    id: 3290,
    name: "PIONEER PUMP LIMITED",
    Address_LineOne: "1-3 KINGS PARKWAY",
    Address_LineTwo: "RATTLESDEN",
    Address_City: "BURY ST EDMUNDS",
    Address_State: "",
    Address_PostalCode: "IP30 0RZ",
    Address_Country: "GB",
    CompanyCode: "03410",
    BrandCode: "088",
    SalesTerritoryCode: "088",
    PaymentTerms: "DUR",
    TaxId: "GB155432028",
  },
  {
    id: 3615,
    name: "FWT WATER TREATMENT-WINNIPEG CANADA",
    Address_LineOne: "3-1599 KENASTON BLVD",
    Address_City: "WINNIPEG",
    Address_State: "MB",
    Address_PostalCode: "R2P 0P7",
    Address_Country: "CA",
    CompanyCode: "03611",
    BrandCode: "088",
    SalesTerritoryCode: "088",
    PaymentTerms: "CIA",
    TaxId: "86827-2436",
  },
];

export const MOCK_USERS = [
  {
    id: "u1",
    email: "jane.doe@example.com",
    firstName: "Jane",
    lastName: "Doe",
  },
  {
    id: "u2",
    email: "john.smith@example.com",
    firstName: "John",
    lastName: "Smith",
  },
  {
    id: "u3",
    email: "alex.lee@example.com",
    firstName: "Alex",
    lastName: "Lee",
  },
  {
    id: "u4",
    email: "maria.garcia@example.com",
    firstName: "Maria",
    lastName: "Garcia",
  },
  {
    id: "u5",
    email: "sam.patel@example.com",
    firstName: "Sam",
    lastName: "Patel",
  },
];

export const defaultStorefronts = [
  { value: "fedirect-us", label: "FE Direct US" },
  { value: "fedirect-canada", label: "FE Direct Canada" },
  { value: "fedirect-europe", label: "FE Direct Europe" },
  { value: "fedirect-uk", label: "FE Direct UK" },
  { value: "fedirect-germany", label: "FE Direct Germany" },
  { value: "fedirect-france", label: "FE Direct France" },
  { value: "fedirect-italy", label: "FE Direct Italy" },
  { value: "fedirect-spain", label: "FE Direct Spain" },
  { value: "fedirect-australia", label: "FE Direct Australia" },
  { value: "fedirect-japan", label: "FE Direct Japan" },
];

export const SAMPLE_CODES = [
  "088",
  "099",
  "F03",
  "F09",
  "F16",
  "F35",
  "F37",
  "F42",
  "F98",
  "G02",
  "G10",
  "G14",
];

export const mockPending = [
  {
    id: 1,
    storefront: "fedirect-us",
    customerNumber: "CUST001",
    email: "john.doe@company.com",
    company: "Tech Solutions Inc",
    firstName: "John",
    lastName: "Doe",
    signupDate: "2024-01-15",
    comments: "Interested in enterprise features",
  },
  {
    id: 2,
    storefront: "fedirect-canada",
    customerNumber: "CUST002",
    email: "sarah.smith@retail.com",
    company: "Retail Plus",
    firstName: "Sarah",
    lastName: "Smith",
    signupDate: "2024-01-18",
    comments: "Looking for bulk pricing",
  },
  {
    id: 3,
    storefront: "fedirect-europe",
    customerNumber: "CUST003",
    email: "mike.johnson@startup.io",
    company: "StartupCo",
    firstName: "Mike",
    lastName: "Johnson",
    signupDate: "2024-01-20",
    comments: "Small business owner",
  },
];
